var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RawLeads"},[_c('div',{staticClass:"RawLeads__buttons-wrapper"},[_c('BulkFileUpload')],1),[_c('v-container',[_c('RawLeadTable',{attrs:{"leads":_vm.rawLeads}})],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }